import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useReconnectingWebSocket } from '../util/WebSocketUtil';

const StatusContext = createContext();

export const useTps = () => useContext(StatusContext).tpsCount;
export const useOnlinePlayers = () => useContext(StatusContext).playerCount;
export const useDataLoad = () => useContext(StatusContext).dataLoadCount;
export const useErrorLogs = () => useContext(StatusContext).errorLogCount;
export const useWarnings = () => useContext(StatusContext).warningsCount;
export const useReports = () => useContext(StatusContext).reportsCount;
export const useFeedback = () => useContext(StatusContext).feedbackCount;
export const useNotifications = () => useContext(StatusContext).notificationsCount;

export const StatusProvider = ({ loggedIn, children }) => {
    const [dataLoadCount, setDataLoadCount] = useState(0);
    const [errorLogCount, setErrorLogCount] = useState(0);
    const [warningsCount, setWarningsCount] = useState(0);
    const [reportsCount, setReportsCount] = useState(0);
    const [feedbackCount, setFeedbackCount] = useState(0);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const [tpsCount, setTpsCount] = useState(0);
    const [playerCount, setPlayerCount] = useState(0);

    const enabled = !!localStorage.getItem('authToken');

    useEffect(() => {
        if (loggedIn) {
            loadDataLoadCount();
            loadErrorCount();
            loadWarningCount();
            loadReportCount();
            loadFeedbackCount();
            loadNotificationsCount();
        }
    }, [loggedIn]);

    useReconnectingWebSocket('/app/dataload', () => loadDataLoadCount(), { enabled });
    useReconnectingWebSocket('/app/counter', (event) => {
        const message = JSON.parse(event.data);
        if (message.errors !== undefined) setErrorLogCount(message.errors);
        if (message.warnings !== undefined) setWarningsCount(message.warnings);
        if (message.reports !== undefined) setReportsCount(message.reports);
        if (message.feedback !== undefined) setFeedbackCount(message.feedback);
    }, { enabled });
    useReconnectingWebSocket('/app/status', (event) => {
        const status = JSON.parse(event.data);
        setTpsCount(status.tps);
    }, { enabled });
    useReconnectingWebSocket('/app/playercount', (event) => {
        const playerCount = JSON.parse(event.data);
        setPlayerCount(playerCount);
    }, { enabled });
    useReconnectingWebSocket('/app/systemonlinestate', (event) => {
        const message = JSON.parse(event.data);
        message.online ? toast.success(`${message.name} is online`) : toast.error(`${message.name} is offline`);
    }, { enabled });
    useReconnectingWebSocket('/app/notification', (event) => {
        const operation = JSON.parse(event.data);
        setNotificationsCount((prev) =>
            operation === 1 ? prev + 1 : operation === -1 ? prev - 1 : 0
        );
    }, { enabled });

    const loadDataLoadCount = () => {
        axios.get('/dataload/selected/count').then(response => setDataLoadCount(response.data));
    };

    const loadErrorCount = () => {
        axios.get('/errorlog/unseen/count').then(response => setErrorLogCount(response.data));
    };

    const loadWarningCount = () => {
        axios.get('/warning/warning/unreviewed/count').then(response => setWarningsCount(response.data));
    };

    const loadReportCount = () => {
        axios.get('/player/report/unreviewed/count').then(response => setReportsCount(response.data));
    };

    const loadFeedbackCount = () => {
        axios.get('/feedback/unseen/count').then(response => setFeedbackCount(response.data));
    };

    const loadNotificationsCount = () => {
        axios.get('/notification/notifications/count').then(response => setNotificationsCount(response.data));
    };

    return (
        <StatusContext.Provider value={{ tpsCount, playerCount, dataLoadCount, errorLogCount, warningsCount, reportsCount, feedbackCount, notificationsCount }}>
            {children}
        </StatusContext.Provider>
    );
};
